import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useCart } from '../contexts/CartContext';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { formatPrice } from '../utils/priceHelpers';
import { config } from '../utils/config';

const Cart = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { items, itemCount, subtotal, updateQuantity, removeItem } = useCart();

  if (itemCount === 0) {
    return (
      <div>
        <Navbar />
        <div className="container" style={{ padding: 40, textAlign: 'center' }}>
          <p style={{ fontSize: 48 }}>🛒</p>
          <h2>Votre panier est vide</h2>
          <Link to="/shop" className="btn btn-primary" style={{ marginTop: 16 }}>
            Parcourir la boutique
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  const deliveryFee = config.LOCAL_DELIVERY_FEE;
  const total = subtotal + deliveryFee;

  return (
    <div>
      <Navbar />
      <div className="container" style={{ padding: '30px 20px', maxWidth: 800 }}>
        <h1 style={{ marginBottom: 24 }}>Panier ({itemCount} article{itemCount > 1 ? 's' : ''})</h1>

        {items.map((item) => (
          <div
            key={item.productId}
            className="card"
            style={{
              display: 'flex',
              gap: 16,
              padding: 16,
              marginBottom: 12,
              alignItems: 'center',
            }}
          >
            {item.thumbnailUrl ? (
              <img
                src={item.thumbnailUrl}
                alt=""
                style={{ width: 72, height: 72, objectFit: 'cover', borderRadius: 8 }}
              />
            ) : (
              <div style={{ width: 72, height: 72, background: '#eee', borderRadius: 8 }} />
            )}
            <div style={{ flex: 1 }}>
              <strong>{item.name}</strong>
              <p style={{ margin: '4px 0', color: '#FF0000' }}>{formatPrice(item.price)}</p>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <button
                  type="button"
                  className="btn btn-secondary"
                  style={{ padding: '4px 10px' }}
                  onClick={() => updateQuantity(item.productId, item.quantity - 1)}
                >
                  −
                </button>
                <span>{item.quantity}</span>
                <button
                  type="button"
                  className="btn btn-secondary"
                  style={{ padding: '4px 10px' }}
                  onClick={() => updateQuantity(item.productId, item.quantity + 1)}
                >
                  +
                </button>
                <button
                  type="button"
                  onClick={() => removeItem(item.productId)}
                  style={{ marginLeft: 12, background: 'none', border: 'none', color: '#dc3545', cursor: 'pointer' }}
                >
                  Retirer
                </button>
              </div>
            </div>
            <strong>{formatPrice(item.price * item.quantity)}</strong>
          </div>
        ))}

        <div className="card" style={{ padding: 20, marginTop: 24 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
            <span>Sous-total</span>
            <span>{formatPrice(subtotal)}</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
            <span>Livraison locale</span>
            <span>{formatPrice(deliveryFee)}</span>
          </div>
          <hr />
          <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 'bold', fontSize: 18 }}>
            <span>Total</span>
            <span style={{ color: '#FF0000' }}>{formatPrice(total)}</span>
          </div>
          <button
            type="button"
            className="btn btn-primary"
            style={{ width: '100%', marginTop: 20 }}
            onClick={() => {
              if (!user) navigate('/login');
              else navigate('/checkout');
            }}
          >
            Passer la commande
          </button>
          <Link to="/shop" style={{ display: 'block', textAlign: 'center', marginTop: 12, color: '#666' }}>
            Continuer mes achats
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Cart;
